import { humanizeName, summaryByKind } from "../../utils/rateConcepts";
import { humanizeCondition } from "../../utils/humanizeCondition";
import { formatCOP } from "../../utils/money";

export default function RateItemsSummary({
  items,
  concepts,
  conditions,
  places,
  onEdit,
  editable
}) {

  return (
    <section className="card summary-card">
      <header className="summary-header">
        <h3>Reglas tarifarias finales</h3>
        {editable && (
          <button
            type="button"
            className="summary-edit"
            onClick={onEdit}
          >
            Editar reglas
          </button>
        )}
      </header>

      <div className="summary-items">
        {items.length === 0 && (
          <p className="muted">No hay reglas tarifarias definidas.</p>
        )}

        {items.map((item) => {
          const concept = concepts.find(
            (c) => c.id === item.concept_id
          );

          const condition = conditions.find(
            (cond) => cond.id === item.condition_group_id
          );

          if (!concept) return null;

          return (
            <div key={item.id} className="summary-item-row">
              {/* Concepto */}
              <div className="item-concept">
                {humanizeName(concept.name)}
              </div>

              {/* Valor */}
              <div className="item-value">
                {formatCOP(item.value_cents/100)}
              </div>

              {/* Unidad */}
              <div className="item-unit">
                {summaryByKind(concept)}

                {condition && (
                  <>
                  <br></br>
                    ({humanizeCondition(condition, { places })})
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

